define('settings/lib/logo/logo',['require','knockout','durandal/app','api-access','api-access','web-urls','file-upload-binding'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var userApi = require('api-access').user;
    var cors = require('api-access').cors;
    var webUrls = require('web-urls');
    var meetingServicesURL = webUrls.get('meetingSvcUrl');
    var baseUrl = webUrls.get('baseUrl');

    require('file-upload-binding');

    return function () {
        var self = this;

        self.usersSettings = ko.observable();

        self.logoURL = ko.observable(meetingServicesURL + '/meeting/rest/2/settings/logo');
        self.logoData = ko.observable();
        self.fileName = ko.observable('');
        self.logoPreviewURL = ko.observable();
        self.logoPreviewURLOriginal = ko.observable();

        /* 3 valid UI states exist
            noLogo: The page is loaded and no logo exists
            existingLogo: The page is loaded and a previous logo already exists
            preview: The user has chosen a logo and it is being previewed in the box
        */
        self.logoUIState = ko.observable();
        self.logoUIStateOriginal = ko.observable();

        self.isHoverOn = ko.observable(false);

        self.hasLogoSizeError = ko.observable(false);
        self.hasLogoFormatError = ko.observable(false);
        self.hasLogoResError = ko.observable(false);
        self.hasLogoError = ko.computed(function () {
            return self.hasLogoSizeError() || self.hasLogoFormatError() || self.hasLogoResError();
        });

        self.revertLogoSettings = function () {
            self.logoUIState(self.logoUIStateOriginal());
            self.logoPreviewURL(self.logoPreviewURLOriginal());
        };

        self.hasLogoError.subscribe(function () {
            if (self.hasLogoError()) {
                self.revertLogoSettings();
            }
        });

        self.setIsHoverOn = function (bool) {
            self.isHoverOn(bool);
        };

        self.setExistingLogo = function () {
            var logoID = self.usersSettings().logoId;
            if (logoID) {
                self.logoUIState('existingLogo');
                self.logoUIStateOriginal('existingLogo');
                self.logoPreviewURL(baseUrl + '/rest/settings/logo/' + logoID);
                self.logoPreviewURLOriginal(self.logoPreviewURL());
            } else {
                self.logoUIState('noLogo');
                self.logoUIStateOriginal('noLogo');
            }
        };

        /* File Uploader functions */
        self.logoAddCallback = function (e, data) {
            data.process().done(function () {
                self.logoData(data);

                /*
                    Preview stuff and File API is only > IE9
                    If File API is not availble, skip the preview and display the file name instead
                */
                var file = data.files[0];
                if (file.type) {
                    if (!(file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/pjpeg')) {
                        self.hasLogoFormatError(true);
                    } else {
                        self.hasLogoFormatError(false);
                    }

                    if (file.size > 100000) {
                        self.hasLogoSizeError(true);
                    } else {
                        self.hasLogoSizeError(false);
                    }

                    if (!self.hasLogoFormatError() && !self.hasLogoSizeError()) {
                        var image = new Image();
                        image.onload = function () {
                            // check if image is garbled
                            if (image.width === 0 || image.height === 0) {
                                self.hasLogoResError(true);
                            }
                            if (image.width && image.height) {
                                if (image.width > 400 || image.height > 200) {
                                    self.hasLogoResError(true);
                                } else {
                                    self.hasLogoResError(false);
                                }
                            } else {
                                self.hasLogoResError(true);
                            }
                            if (!self.hasLogoError()) {
                                self.logoUIState('preview');
                                self.logoPreviewURL(image.src);
                            }
                        };
                        image.src = URL.createObjectURL(file);
                    }
                } else {
                    self.fileName(file.name);
                    self.logoPreviewURL('');
                    self.logoUIState('preview');
                }
                self.isHoverOn(false);
            });
        };

        self.deleteLogo = function () {
            self.logoUIState('noLogo');
            self.logoPreviewURL('');
            self.hasLogoSizeError(false);
            self.hasLogoFormatError(false);
            self.hasLogoResError(false);
        };

        self.submitLogo = function () {
            if (self.logoUIState() === 'noLogo') {
                userApi.deleteLogo().then(function () {
                    self.logoUploadDone();
                });
            } else {
                self.logoData().submit();
            }
            self.fileName('');
        };

        self.logoUploadDone = function () {
            cors.clearCache();
            window.mixpanel.track('Upload Logo');

            app.trigger('settings:save');

            userApi.settings().then(function (settings) {
                self.usersSettings(settings);
                self.setExistingLogo();
            });
        };

        self.logoUploadFail = function (e, data) {
            if (data.jqXHR === 400) {
                self.hasLogoError(true);
            }
        };

        self.activate = function () {
            return userApi.settings()
                .then(function (data) {
                    self.usersSettings(data);
                });
        };

        self.attached = function () {
            self.setExistingLogo();
        };
    };
});

